import { Posts } from "../post";

export const Articles = ({ getUserPost }: { getUserPost?: boolean }) => {
  return <Posts getUserPost={getUserPost} isArticle />;
};
